import { render, staticRenderFns } from "./InstructionsLadderForList.vue?vue&type=template&id=4f65d1b2&"
import script from "./InstructionsLadderForList.vue?vue&type=script&lang=js&"
export * from "./InstructionsLadderForList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports